<template>
	<div class="attribute">
		<div class="variation-toggle">
			<div class="d-flex align-items-start">
				<smart-toggle
					class="pt-1"
					size="small"
					v-model="enabledValue"
					@input="onEnabledChange"
				/>
				<label><b>{{ displayName }}</b></label>
			</div>
			<div v-if="enabledError" class="text-danger">
				{{ getErrorMessage('product', 'variationEnabled') }}
			</div>
		</div>
		<div class="row">
			<!-- Price -->
			<div class="col-xl-6">
				<div class="input-group mb-2">
					<div class="input-group-prepend"><div class="input-group-text">{{ currency }}</div></div>
					<input type="text" class="input form-control" min="0" @change="onPriceChange" :value="price">
					<div class="input-group-append" v-if="index === 0">
						<div
							class="input-group-text attribute-input-apply"
							v-tooltip="'Apply to all variations'"
							@click="applyAll('price', price); applyAll('cogs', cogs)">
							<i class="material-icons md-1">filter_none</i>
						</div>
					</div>
				</div>
			</div>

			<!-- Weight -->
			<div class="col-xl-6">
				<div class="input-group">
					<div class="input-group-prepend"><div class="input-group-text">Weight (gr)</div></div>
					<input type="number" class="input form-control" min="0" @change="onWeightChange" :value="weightValue">
					<div class="input-group-append" v-if="index === 0">
						<div
							class="input-group-text attribute-input-apply"
							v-tooltip="'Apply to all variations'"
							@click="applyAll('weight', weight)">
							<i class="material-icons md-1">filter_none</i>
						</div>
					</div>
				</div>
				<div v-if="weightError" class="text-danger">
					{{ getErrorMessage('product', 'weight') }}
				</div>
			</div>

			<!-- COGS -->
			<div class="col-xl-6 mt-2 hidden">
				<!-- <label>COGS <span class="optional">(optional)</span> <i class="material-icons info" v-tooltip="'Cost of Goods Sold / Harga Pokok'">info</i></label> -->
				<label>Harga Supplier ke Ostock</label>
				<div class="input-group mb-2">
					<div class="input-group-prepend"><div class="input-group-text">{{ currency }}</div></div>
					<input type="text" class="input form-control" min="0" @change="onCogsChange" :value="cogs" readonly>
					<!-- <div class="input-group-append" v-if="index === 0">
						<div
							class="input-group-text attribute-input-apply"
							v-tooltip="'Apply to all variations'"
							@click="applyAll('cogs', cogs)">
							<i class="material-icons md-1">filter_none</i>
						</div>
					</div> -->
				</div>
			</div>

			<!-- Variant Code -->
			<div class="col-xl-6 mt-2">
				<label>{{ $t('Variation Code')}} <span class="optional">(optional)</span> <i class="material-icons info" v-tooltip="'SKU / Variation Code / Kode Varian'">info</i></label>
				<input
					type="text"
					class="input form-control"
					@change="onVariantCodeChange"
					:value="variant_code"
				>
			</div>

			<!-- Pcs Labeling Code -->
			<div class="col-xl-6 mt-2">
				<label>Additional PCS Information</label> <i class="material-icons info" v-tooltip="'Jika produk berupa paket bundling, masukan jumlah item'">info</i>
				<div class="input-group mb-2">
					<input type="text" class="input form-control" min="1" :value="uom.value" @change="onUomChange">
					<div class="input-group-append"><div class="input-group-text">PCS</div></div>
				</div>
			</div>

			<!-- Wholesale Price -->
			<!-- disabled by request -->
			<!-- <div class="col-xl-6 d-flex justify-content-left align-items-center">
				<div class="text-center mt-3">
					<button class="attribute-wholesale btn btn-plain p-0" @click="$emit('show-wholesale')">{{ $t('Add / Edit Wholesale Price') }}</button>
					<div class="text-danger" v-if="wholesaleError">Wholesale Price Error</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { parseNumber, duplicateVar } from '@/lib/helper';
import SmartToggle from '@/components/SmartToggle.vue';
// import PriceInput from './PriceInput.vue';

export default {
	name: 'productAttributePrice',
	components: {
		// PriceInput,
		SmartToggle,
	},
	props: {
		index: {
			type: Number,
		},
		name: {
			type: String,
		},
		price: {},
		weight: {},
		cogs: {},
		variant_code: {},
		currency: {
			type: String,
			default: 'Rp',
		},
		wholesale: {
			type: Array,
			default: () => [],
		},
		wholesaleError: {
			type: Boolean,
			default: false,
		},
		commissionPercentage: {
			type: Number,
			default: 5,
		},
		outsourceCommission: {
			type: Object,
			default: null,
		},
		weightError: {
			type: Boolean,
			default: false,
		},
		uom: {
			type: Object,
			default: null,
		},
		enabled: {
			type: Boolean,
			default: true,
		},
		enabledError: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			enabledValue: this.enabled,
		};
	},
	methods: {
		onPriceChange(e) {
			const value = e.target.value;
			this.$emit('update:price', value);
			const parsedPrice = parseNumber(value);
			this.$emit('update:price', parsedPrice);
			const comPrice = parsedPrice - this.getCommissionValue(parsedPrice);
			this.$emit('update:cogs', comPrice);
			this.$forceUpdate();
			this.$emit('change');
		},
		onWeightChange(e) {
			const value = e.target.value;
			const parsedWeight = parseNumber(value);
			this.$emit('update:weight', parsedWeight);
			this.$forceUpdate();
			this.$emit('change');
		},
		onUomChange(e) {
			const value = e.target.value < 1 ? 1 : e.target.value;
			const uom = {
				type: 'pcs',
				value: parseNumber(value),
			};
			this.$emit('update:uom', uom);
		},
		onCogsChange(e) {
			const value = e.target.value;
			this.$emit('update:cogs', value);
			const parsedCogs = parseNumber(value);
			this.$emit('update:cogs', parsedCogs);
			this.$forceUpdate();
			this.$emit('change');
		},
		onVariantCodeChange(e) {
			const value = e.target.value;
			this.$emit('update:variant_code', value);
			this.$forceUpdate();
			this.$emit('change');
		},
		onEnabledChange(value) {
			this.$emit('update:enabled', value);
			this.$forceUpdate();
			this.$emit('change');
		},
		applyAll(type, value) {
			const params = { type, value };
			this.$emit('apply-all', params);
		},
		getCommissionValue(currentPrice) {
			let commissionValue = 0;

			if (this.outsourceCommission !== null) {
				if (this.outsourceCommission?.type === 'percentage') {
					const commissionPercentage = this.outsourceCommission?.value ?? 5;
					commissionValue = (currentPrice * (commissionPercentage / 100));
				} else if (this.outsourceCommission?.type === 'nominal') {
					commissionValue = this.outsourceCommission?.value ?? 0;
				}
			} else {
				commissionValue = (currentPrice * (this.commissionPercentage / 100));
			}

			return commissionValue;
		},
	},
	computed: {
		...mapGetters({
			getErrorMessage: 'productCreator/getErrorMessage',
			isHasFeature: 'isHasFeature',
		}),
		displayName() {
			return this.name.replace(/\|\|/g, ' - ');
		},
		weightValue() {
			return this.weight !== '' ? this.weight : 0;
		},
	},
	watch: {
		enabled() {
			this.enabledValue = duplicateVar(this.enabled);
		},
	},
};
</script>

<style lang="scss">
	.attribute-wholesale {
		margin-top: .2em;
		font-weight: bold;
	}
	.attribute {
		.info {
			top: -2px;
		}
	}
	.attribute-input-apply {
		cursor: pointer;
	}
</style>
